import { render } from "./settings-sidebar.vue?vue&type=template&id=01ce7464"
import script from "./settings-sidebar.vue?vue&type=script&lang=js"
export * from "./settings-sidebar.vue?vue&type=script&lang=js"

import "./settings-sidebar.vue?vue&type=style&index=0&id=01ce7464&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__